import { Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import Flex from '../Flex';
import Text from '../Text';
import ChecklistItem from './ChecklistItem';
const Checklist = /*#__PURE__*/React.memo(_ref => {
  let {
    flexDirection = 'column',
    fontSize = 1,
    gutter = 0,
    items,
    name,
    value = []
  } = _ref;
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: flexDirection,
    fontSize: fontSize
  }, items.map((item, i) => /*#__PURE__*/React.createElement(Flex, {
    key: item.label,
    as: "label",
    sx: {
      alignItems: 'center',
      mb: gutter
    }
  }, /*#__PURE__*/React.createElement(Field, {
    name: name,
    values: value,
    value: item.value,
    component: ChecklistItem
  }), /*#__PURE__*/React.createElement(Text, null, item.label))));
});
Checklist.propTypes = {
  items: PropTypes.array.isRequired
};
Checklist.displayName = 'Checklist';
export default Checklist;